import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { DataProvider } from '../../providers/data';
import { Location } from '@angular/common';
import { AppSettings } from '../../app/app.settings';
import { Product, ProductFav } from '../../models/product';
import { QuestionnairePage } from '../questionnaire/questionnaire';
import { AskPage } from '../ask/ask';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-favourite-detailed',
  templateUrl: 'favourite-detailed.html',
})
export class FavouriteDetailedPage {
  get currentLang() {
    let lang = localStorage.getItem('es-language') || AppSettings.DEFAULT_LANGUAGE;

    if (this.curCountry === 'uk') {
      lang = 'en';
    }
    return lang;
  }

  public curCountry: string;
  public currentProductId: number;
  public currentProductType: string;
  public currentProduct: Product = new Product();

  constructor(private iab: InAppBrowser,
              public navCtrl: NavController,
              public navParams: NavParams,
              private dataService: DataProvider,
              public alertCtrl: AlertController/*, public analyticsService: AnalyticsService*/) {
    this.currentProductId = +navParams.get('id');
    this.currentProductType = <string>navParams.get('type');

    this.curCountry = dataService.CURRENT_COUNTRY;
  }

  ionViewDidLoad() {
    this.dataService.getProductsByIDs([this.currentProductId]).subscribe(productsData => {
      if (productsData.length > 0) {
        this.currentProduct = productsData[0];

        this.dataService.getProductsExtByIDs([this.currentProductId]).subscribe(productsExtData => {
          if (productsExtData.length > 0) {
            this.currentProduct.productExt = productsExtData[0];
          }
        });
      }
    });
  }

  public getProductName(currentProduct: Product): string {
    return currentProduct['name_' + this.currentLang] || currentProduct['name'] || "";
  }

  public getProductBenefits(currentProduct: Product): string[] {
    //let benefitsCount = currentProduct['benefits_' + this.currentLang + '_take_detail'] || currentProduct['benefits_take_detail'];
    let benefitsStr = currentProduct['benefits_' + this.currentLang] || currentProduct['benefits'] || "";
    return benefitsStr ? benefitsStr.trim().split('\n')/*.slice(0, benefitsCount ? +benefitsCount : Number.MAX_VALUE)*/ : [];
  }

  public backButtonClick() {
    this.navCtrl.pop();
  }

  public confirmRemoveFavProduct() {
    let mainThis = this;
    let alert = this.alertCtrl.create({
      title: 'Сonfirmation',
      message: 'Remove product from favourites?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => { }
        },
        {
          text: 'Yes',
          handler: () => {
            mainThis.removeFavProduct();
          }
        }
      ]
    });

    alert.present();
  }

  public removeFavProduct() {
    let favProds: ProductFav[] = this.dataService.getFavProducts();
    let currProdIndex = favProds.map(p => p.id).indexOf(this.currentProduct.id);
    if (currProdIndex !== -1) {
      favProds.splice(currProdIndex, 1);
    }
    this.dataService.setFavProducts(favProds);
    //this.refreshProducts();
    this.backButtonClick();
  }

  public askAboutProduct() {
    this.dataService.PRODUCT_ID_FOR_ASK = this.currentProductId;
    //this.navCtrl.push(AskPage, { product_id: this.currentProductId });
    this.navCtrl.parent.select(2);
  }

  public openUrl(url: any) {
    const browser = this.iab.create(url);
    browser.show();
  }
}



// WEBPACK FOOTER //
// ./src/pages/favourites/favourite-detailed.ts